module.exports = __webpack_public_path__ + "static/flapstrat-440e0046884c8056f3d2f2a88d9993c5.png";